
import Box from 'vux/src/components/box/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import { getPriceWeight, initWxJSSDK } from "../../common/js/api.js";
import wx from "weixin-js-sdk";

export default {
components: {
Box,
Icon,
XButton
},
data() {
return {
unitPriceInfo:{unitPrice:0.5},
canDraw:0,
};
},
methods: {
backIndex() {
const self = this;
wx.miniProgram.navigateTo({
url: '/pages/index/index',
fail: () =>  {
self.$vux.toast.text('小程序更新中,请稍后再试!', 'middle')
}
})
},
close() {
this.$wechat.closeWindow();
}
},
created() {
let self = this;
self.canDraw = this.$route.query.canDraw;
document.title = "预约完成";
if( self.canDraw==1 || self.canDraw=='1' ){

self.canDraw = 1;
}else if(self.canDraw == 2 || self.canDraw == '2'){

self.canDraw = 2;
}else if(self.canDraw == 3 || self.canDraw == '3') {

self.canDraw = 3;
} else {

self.canDraw = 0;
}
getPriceWeight({}).then(function(data) {
self.unitPriceInfo = data.Content
})



},
mounted() {
initWxJSSDK();
}
};



// WEBPACK FOOTER //
// ./src/components/usercenter/appointmentSuccessH5Community.vue